import { TableStateModel } from '@servicetitan/table';

export const getInitialTableState = (): TableStateModel => ({
    skip: 0,
    sort: [],
    group: [],
    aggregates: [],
    selectedIds: [],
    expandedIds: [],
    collapsedGroups: [],
});
